/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class UserActionDynamicLabelsEvents {
}
UserActionDynamicLabelsEvents.USER_ACTION_DYNAMIC_LABELS_CHANGED_EVENT = 'dell.sirius.user-action-dynamic-labels.changed';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci1hY3Rpb24tZHluYW1pYy1sYWJlbHMtZXZlbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3NoYXJlZC9keW5hbWljLWxhYmVscy91c2VyLWFjdGlvbi1keW5hbWljLWxhYmVscy1ldmVudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8sNkJBQTZCOztBQUNmLHNFQUF3QyxHQUFHLGdEQUFnRCxDQUFDIn0=